<template>
    <el-card class="staff-list">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
                :lazy="true"
                v-if="$$filterPermission('员工-员工列表及课时费设置-查看员工列表')"
                :label="$t('Staff.list')"
                name="first">
                <!-- 筛选 -->
                <el-form
                    label-width="10px"
                    label-position="right"
                    class="w-full flex flex-wrap items-center">
                    <el-form-item style="width:240px">
                        <el-input
                            v-model="form.content"
                            :placeholder="$t('Staff.placeholder_search')"
                            class="w-full" clearable/>
                    </el-form-item>
                    <el-form-item style="width:120px">
                        <el-select
                            v-model="form.storeId"
                            :placeholder="$t('Common.all_store2')"
                            class="w-full" clearable>
                            <el-option
                                v-for="(item, index) in stores"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item style="width:120px">
                        <el-select
                            v-model="form.jobStatusCode"
                            :placeholder="$t('Staff.Incumbency')"
                            class="w-full"
                            clearable>
                            <el-option :label="$t('Staff.be_on_the_job')" :value="1"/>
                            <el-option :label="$t('Staff.practice')" :value="2"/>
                            <el-option :label="$t('Staff.part-timejob')" :value="3"/>
                            <el-option :label="$t('Staff.dimission')" :value="4"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="width:120px">
                        <el-select
                            v-model="form.roleId"
                            :placeholder="$t('Staff.Job_selection')"
                            class="w-full"
                            clearable>
                            <el-option
                                v-for="(item, index) in roles"
                                :key="index"
                                :label="item.name"
                                :value="item.id"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item style="width:120px">
                        <el-select
                            v-model="form.active"
                            :placeholder="$t('Reception.Fourth.status')"
                            class="w-full" clearable>
                            <el-option :label="$t('Reception.Fifth.normal')" :value="true"/>
                            <el-option :label="$t('Lesson.deleted')" :value="false"/>
                            <el-option :label="$t('Staff.All_States')" :value="null"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        class="width:420px el-input--small"
                        :label="$t('Staff.date_on_board')"
                        label-width="80px">
                        <el-date-picker
                            v-model="date"
                            type="daterange"
                            range-separator="-"
                            :start-placeholder="$t('Reception.Third.time_placeholder')"
                            :end-placeholder="$t('Reception.Third.time_placeholder')"
                            value-format="yyyy-MM-dd"
                        />
                    </el-form-item>
                    <el-form-item style="width:200px" label-width="70px">
                        <el-button type="primary" @click="fetchStaff(1)">{{ $t('Common.screen') }}</el-button>
                        <el-button @click="handleResetStaff">{{ $t('Common.clear') }}</el-button>
                    </el-form-item>
                </el-form>
                <!-- 编辑 -->
                <div class="staff-edit-icon">
                    <el-tooltip effect="dark" :content="$t('Staff.New_employees')" placement="bottom">
                        <el-button class="el-button-ui iconfont icon-fitness-add-staff" @click="handleAdd" />
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('tooltip.check')" placement="bottom">
                        <el-button class="el-button-ui iconfont icon-fitness-yanjing2" @click="handleShow" />
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('tooltip.edit')" placement="bottom">
                        <el-button
                            class="iconfont
                            icon-fitness-icon-test-copy-copy-copy-copy-copy-copy-copy-copy-copy
                            el-button-ui"
                            @click="handleEdit"
                        />
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('Staff.attend')" placement="bottom">
                        <el-button class="el-button-ui iconfont icon-fitness-jilu" @click="staffLesson"/>
                    </el-tooltip>
                    <!-- <el-tooltip effect="dark" content="锁定账号" placement="bottom">
                        <el-button class="el-button-ui iconfont icon-fitness-suo"/>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="解锁" placement="bottom">
                        <el-button class="el-button-ui iconfont icon-fitness-jiesuo"/>
                    </el-tooltip> -->
                    <el-tooltip effect="dark" :content="$t('tooltip.refresh')" placement="bottom">
                        <el-button class="el-button-ui iconfont icon-fitness-huifu1" @click="handleRestore"/>
                    </el-tooltip>
                    <el-tooltip effect="dark" :content="$t('tooltip.delete')" placement="bottom">
                        <el-button class="el-button-ui iconfont icon-fitness-shanchu" @click="handleDelete" />
                    </el-tooltip>
                    <!-- <el-button type="success" >团课教练课时费设定</el-button> -->
                </div>
                <el-table
                    border
                    highlight-current-row
                    :data="staffs"
                    class="my-4"
                    @current-change="handleCurrentChange">
                    <el-table-column prop="id" :label="$t('Common.id')" align="center" v-if="false"/>
                    <el-table-column prop="roleNames" :label="$t('Staff.role')" align="center"/>
                    <el-table-column prop="jobNum" :label="$t('Staff.job_number')" align="center" width="120"/>
                    <el-table-column prop="name" :label="$t('Staff.actual_name')" align="center"/>
                    <el-table-column prop="phone" :label="$t('Common.phone_number')" align="center"/>
                    <el-table-column prop="nickname" :label="$t('Staff.nickname')" align="center"/>
                    <el-table-column prop="storeNames" :label="$t('Common.store')" align="center"/>
                    <el-table-column :label="$t('Staff.Incumbency')" align="center" prop="jobStatus"/>
                    <el-table-column :label="$t('Reception.Fourth.status')" align="center" width="120">
                        <template slot-scope="{$index, row}" v-if="row.active !== ''">
                            <span :class="row.active ? 'task-status' : 'del-status'">
                                {{ row.active ? $t('Reception.Fifth.normal') : $t('Lesson.deleted') }}
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    v-if="staffs && staffs.length"
                    class="text-right"
                    @current-change="fetchStaff"
                    :current-page.sync="pagination.page"
                    :page-size="pagination.size"
                    layout="total, prev, pager, next, jumper"
                    :total="pagination.total"
                ></el-pagination>
            </el-tab-pane>

            <el-tab-pane
                :lazy="true"
                v-if="$$filterPermission('员工-员工权限管理-设定及管理员工权限')"
                :label="$t('Staff.Employee_Rights_Manage')"
                name="forth">
                <permission-list />
            </el-tab-pane>
        </el-tabs>
        <staff-form ref="StaffForm" @fetchStaff="fetchStaff"/>
        <!-- 设置员工可上课程 -->
        <staff-course-form ref="staffLesson" />
    </el-card>
</template>

<script>
import {
    Tooltip,
    Popover,
    DatePicker,
    Table,
    TableColumn,
    Pagination,
    Tag,
    Tabs,
    TabPane,
    OptionGroup,
    Dialog,
    Tree,
    CheckboxGroup,
    Checkbox,
} from 'element-ui';
import StaffForm from '@/components/Dialog/StaffForm';
import StaffCourseForm from '@/components/Dialog/Staff/StaffCourseForm';
import PermissionList from '@/components/widget/Staff/PermissionList';

export default {
    components: {
        Tooltip: Tooltip,
        Popover: Popover,
        ElDatePicker: DatePicker,
        ElTable: Table,
        ElTableColumn: TableColumn,
        ElPagination: Pagination,
        ElTag: Tag,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        ElOptionGroup: OptionGroup,
        ElDialog: Dialog,
        ElTree: Tree,
        ElCheckboxGroup: CheckboxGroup,
        ElCheckbox: Checkbox,
        StaffForm,
        StaffCourseForm,
        PermissionList,
    },
    mixins: [require('../../mixins/CacheQuery').default],
    data() {
        return {
            // 员工
            input: '',
            roles: [],
            staffs: [],
            selectStaff: [],
            form: {
                id: '',
                content: '',
                storeId: '',
                jobStatusCode: '',
                active: '',
                page: 1,
            },
            // 员工权限管理
            stores: [],
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
            loading: false,
            update: false,
            date: null,
            editableTabs: [
                {
                    name: 'first',
                    isShow: this.$$filterPermission('员工-员工列表及课时费设置-查看员工列表'),
                }, {
                    name: 'forth',
                    isShow: this.$$filterPermission('员工-员工权限管理-设定及管理员工权限'),
                },
            ],
            editPermission: this.$$filterPermission('员工-员工列表及课时费设置-添加、修改、删除员工、设置可上课程'),
        };
    },
    watch: {},
    methods: {
        handleClick() {},
        // 员工
        fetchStaff(page = null) {
            if (page) this.pagination.page = page;
            this.loading = true;
            if (this.date && this.date.length) {
                this.form.minWorkedAt = this.date[0];
                this.form.maxWorkedAt = this.date[1];
            } else {
                this.form.minWorkedAt = null;
                this.form.maxWorkedAt = null;
            }
            API.get('staff/pages', {
                params: {
                    ...this.form,
                    ...this.pagination,
                },
            }).then(res => {
                this.staffs = res.content;
                this.pagination.total = res.totalElements;
            }).finally(() => {
                this.update = false;
                this.loading = false;
            });
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        fetchRole() {
            API.get('role/list').then(res => {
                this.roles = res;
            });
        },
        handleResetStaff() {
            this.form = {
                content: '',
                storeId: '',
                jobStatusCode: '',
                active: '',
                minWorkedAt: null,
                maxWorkedAt: null,
            };
            this.date = [];
            this.fetchStaff(1);
        },
        handleAdd() {
            if (this.editPermission) this.$refs.StaffForm.open(null);
            else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: () => {},
                });
            }
        },
        handleEdit() {
            if (this.validSelect() && this.editPermission) this.$refs.StaffForm.open(this.selectStaff);
            else if (this.validSelect() && !this.editPermission) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: () => {},
                });
            }
        },
        handleShow() {
            if (this.editPermission) {
                this.$router.push({
                    name: 'Staff.Show',
                    params: { id: this.selectStaff.id },
                });
            } else {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: () => {},
                });
            }
        },
        handleDelete() {
            if (this.validSelect()) {
                $ele.$confirm(this.$t('Staff.Confirm_del_employee'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    if (this.editPermission) {
                        API.delete(`staff/${this.selectStaff.id}/active`).then(() => {
                            $ele.$message.success(this.$t('Message.delete_success'));
                            this.fetchStaff();
                        });
                    } else {
                        $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                            confirmButtonText: this.$t('Message.confirm'),
                            callback: () => {},
                        });
                    }
                }).catch(() => {
                    // $ele.$message.info('已取消删除');
                });
            }
        },
        handleRestore() {
            if (this.validSelect()) {
                $ele.$confirm(this.$t('Staff.Confirm_recover_employee'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    if (this.editPermission) {
                        API.put(`/staff/${this.selectStaff.id}/active`).then(() => {
                            $ele.$message.success(this.$t('Common.message.successRestore'));
                            this.fetchStaff();
                        });
                    } else {
                        $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                            confirmButtonText: this.$t('Message.confirm'),
                            callback: () => {},
                        });
                    }
                }).catch(() => {
                    // $ele.$message.info('已取消恢复');
                });
            }
        },
        validSelect() {
            if (!this.selectStaff || !this.selectStaff.id) $ele.$message.warning(this.$t('Message.choose_one'));
            else return true;
        },
        handleCurrentChange(val) {
            this.selectStaff = val;
        },
        staffLesson() {
            if (this.validSelect() && this.editPermission) {
                this.$refs.staffLesson.open(this.selectStaff);
            } else if (this.validSelect() && !this.editPermission) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: () => {},
                });
            }
        },
    },
    created() {
        if (this.$$filterPermission('员工-员工列表及课时费设置-查看员工列表')) {
            this.fetchStaff();
        }
        this.fetchRole();
        this.fetchStore();
    },
};
</script>
<style lang="scss">
.staff-list {
    .el-button-ui {
        border: none;
        line-height: 0;
        padding: 0px;
        margin-right: 0px;
        font-size: 19px;
        min-height: 20px;
    }
    .staff-edit-icon {
        position: relative;
        float: right;
        margin-right: 1%;
        margin-top: 5px;
        margin-bottom: 5px;
    }
    .task-status {
        color: #2a9546;
    }
    .del-status {
        color:#ce6969;
    }
}
</style>
